import reducer from "./reducer";
import { configureStore } from "@reduxjs/toolkit";

// const store = configureStore({
//   reducer: reducer
// })

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  })
})

export { store }